import { createStatePropertySelector } from "../../../helpers";
import { selectOpportunitiesSlice } from "../../../store/selectors";

const select = createStatePropertySelector(selectOpportunitiesSlice);

export const selectActiveWebsite = select("selectedWebsite");
